import React from "react";

export default function ButtonLeftTitle({title, subtitle}) {
    return(
        <div style={{position:"absolute", left:"20px", bottom:"20px", width:"auto", 
        height:"60px", backgroundColor:"var(--black-color-90)", borderRadius:"10px",
        display:"flex", alignItems:"center", justifyContent:"center", boxSizing:"border-box", 
        paddingLeft:"15px", paddingRight:"15px"}}>
            <h1 style={{margin:"0px 0px 5px", fontSize:"2rem", fontFamily:"FuturaNewBold", 
            fontWeight:"100", color:"var(--font-color-yellow)"}}>
                {title}
            </h1>
            <h2 style={{margin:"5px 0px", fontSize:"1.7rem", fontFamily:"FuturaNewBook", 
            fontWeight:"100", color:"var(--font-color-white)", marginLeft:"10px"}}>
                {subtitle}
            </h2>
        </div>
    );
}